import {createAsyncThunk} from '@reduxjs/toolkit';

import {getMenuStructure} from './menu-slice-api';
import {MENU_SLICE} from './menu-slice-constants';

export const loadMenuStructure = createAsyncThunk(
    `${MENU_SLICE}/loadMenuStructure`,
    async (arg, {rejectWithValue}) => {
        try {
            const {data} = await getMenuStructure();
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
